/**
 * 小票二级导航tabbar
 */
export enum RECEIPT_TABS {
  /** 小票审核 */
  EXAMINE = 'examine',
  /** 上传小票 */
  UPLOAD = 'upload',
}